// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowItem_root__IMqrJ","info":"FlowItem_info__3jgXx","info_title":"FlowItem_info_title__2MJHq","info_owner":"FlowItem_info_owner__3sn5y","actions":"FlowItem_actions__1agMV"};